import React, { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import InlineMarkup from './InlineMarkup';

function PolicyBlock({ block }) {
  if (block.type === 'subheading') return <h3><InlineMarkup html={block.html} /></h3>;
  if (block.type === 'paragraph') return <p><InlineMarkup html={block.html} /></p>;
  const ListTag = block.type === 'ordered-list' ? 'ol' : 'ul';
  return (
    <ListTag>
      {block.items.map((item, index) => <li key={index}><InlineMarkup html={item} /></li>)}
    </ListTag>
  );
}

export function PolicyContents({ policy }) {
  return (
    <nav className="apps-policy-toc" aria-label="Policy contents">
      <h2>Contents</h2>
      <ol>
        {policy.tableOfContents.map((entry) => (
          <li key={entry.id}><a href={`#${entry.id}`}>{entry.label}</a></li>
        ))}
      </ol>
    </nav>
  );
}

export function PolicyArticle({ policy, appName = policy.app, children }) {
  const { hash } = useLocation();
  const initialHash = useRef(hash);
  const article = useRef(null);

  useLayoutEffect(() => {
    // Initial browser anchor resolution runs before React mounts policy headings.
    let id;
    try { id = decodeURIComponent(initialHash.current.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (target && article.current.contains(target)) target.scrollIntoView({ behavior: 'instant', block: 'start' });
  }, []);

  return (
    <article ref={article} className="apps-policy-article" aria-labelledby="policy-article-heading">
      <h2 id="policy-article-heading" className="apps-eyebrow" style={{ margin: 0 }}>{appName} app privacy policy</h2>
      {policy.intro.map((block, index) => <PolicyBlock key={`intro-${index}`} block={block} />)}
      {policy.sections.map((section) => (
        <section key={section.id} aria-labelledby={section.id}>
          <h2 id={section.id}>
            {section.heading}
            <a className="apps-heading-anchor" href={`#${section.id}`} aria-label={`Link to section: ${section.heading}`}>#</a>
          </h2>
          {section.blocks.map((block, index) => <PolicyBlock key={`${section.id}-${index}`} block={block} />)}
        </section>
      ))}
      {children}
    </article>
  );
}
